import { html, nothing } from 'lit';
// Registers <d3-step-indicator> (and the rest of d3-kit's elements).
import '@dice-driven/d3-kit';
import { stepIndex } from '../../lib/onboarding.js';

/**
 * The step indicator above an onboarding step: the freelancer's steps (see
 * onboardingSteps) with the one showing marked. Nothing for a single step,
 * such as re-accepting one updated document.
 *
 * @param {Array<{ key: string, label: string }>} steps
 * @param {string} key - the step showing
 */
export function renderOnboardingSteps(steps, key) {
    const current = stepIndex(steps, key);
    if (steps.length < 2 || current < 0) return nothing;
    return html`<d3-step-indicator .steps="${steps.map((s) => s.label)}" .current="${current}"></d3-step-indicator>`;
}
